import { AuthProvider } from "@certn/auth";
import { CascadiaProvider } from "@certn/cascadia-react";
import { EventTrackingProvider } from "@certn/utils";
import { PropsWithChildren } from "react";
import { RouterProvider } from "react-aria-components";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { DocumentLanguageSync } from "./components/DocumentLanguageSync";
import { Debug } from "./debug";
import { SubsidiaryChangeProvider } from "./providers/SubsidiaryChangeProvider";
import constants, {
  AUTH0_AUDIENCE,
  AUTH0_CALLBACK_URL,
  DOMAIN,
} from "../constants";

export function Providers(props: PropsWithChildren) {
  const navigate = useNavigate();
  const { children } = props;

  const { i18n } = useTranslation();

  return (
    <RouterProvider navigate={navigate}>
      <EventTrackingProvider>
        <AuthProvider
          domain={constants.VITE_AUTH0_DOMAIN}
          clientId={constants.VITE_AUTH0_CLIENT_ID}
          apiUrl={DOMAIN}
          authorizationParams={{
            redirect_uri: AUTH0_CALLBACK_URL,
            audience: AUTH0_AUDIENCE,
            scope: constants.VITE_AUTH0_SCOPES,
          }}
        >
          <CascadiaProvider
            locale={i18n.language}
            googleMapsApiKey={constants.VITE_GOOGLE_MAPS_API_KEY}
          >
            <SubsidiaryChangeProvider>
              <DocumentLanguageSync />
              {children}
            </SubsidiaryChangeProvider>
            <Debug />
          </CascadiaProvider>
        </AuthProvider>
      </EventTrackingProvider>
    </RouterProvider>
  );
}
